import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, setToken, setRefreshToken/* , setTokenExpiresIn */ } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { refreshToken } from '@/api/admin.js'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  console.log('回调')

  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // 获取权限列表
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roles } = await store.dispatch('user/getRoles')
          if (roles.length <= 0) {
            // await store.dispatch('user/resetToken')
            Message.error('请设置适配菜单后登陆系统')
            // next(`/login?redirect=${to.path}`)
            to.path === '/dashboard/index' ? next() : next('/dashboard/index')
            NProgress.done()
            return
          } else {
            // generate accessible routes map based on roles
            const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
            // dynamically add accessible routes
            router.addRoutes(accessRoutes)
            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next({ ...to, replace: true })
          }
        } catch (error) {
          if (error === 'token过期') {
            refreshToken().then((data) => {
              const token = data.data.access_token
              // const expires_in = parseInt(data.expires_in) + (Date.parse(new Date()) / 1000)
              const refresh_token = token
              /*
                commit('SET_TOKEN', token)
                commit('SET_EXPIRED_IN', expires_in)
                commit('SET_REFRESH_TOKEN', refresh_token)*/

              setToken(token)
              // setTokenExpiresIn(expires_in)
              setRefreshToken(refresh_token)

              next(to.path)
            }).catch(() => {
              next(`/login?redirect=${to.path}`)
            })
          } else {
            // remove token and go to login page to re-login
            await store.dispatch('user/resetToken')
            Message.error(error || 'Has Error')
            next(`/login?redirect=${to.path}`)
            NProgress.done()
          }
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
